import * as Yup from "yup";
import { THeatmapConfig } from "../../../api/types/Heatmap";

export type THeatmapConfigFormValues = THeatmapConfig & {
  group_selector: string;
  // selected_groups: string[] | { label: string; value: string }[];
};

const defaultColors = [
  "#68E524", // green
  "#FFE600", // yellow
  "#FFB114", // orange
  "#FF3816", // red
];

export const heatmapAdminInitialValues: THeatmapConfigFormValues = {
  start_event_code: "",
  end_event_code: "",
  legends: [
    { color: defaultColors[0], start_hour: 0, end_hour: 2 },
    { color: defaultColors[1], start_hour: 2, end_hour: 4 },
    { color: defaultColors[2], start_hour: 4, end_hour: 6 },
    { color: defaultColors[3], start_hour: 6, end_hour: 12 },
  ],
  groups: [],
  group_selector: "",
  // selected_groups: [],
};

export const heatmapAdminYupValidationSchema = Yup.object().shape({
  start_event_code: Yup.string().required("Start Event Code is required"),
  end_event_code: Yup.string()
    .required("End Event Code is required")
    .test(
      "start-end-cannot-be-same",
      "Cannot be same as Start Event Code",
      function (value) {
        const { start_event_code } = this.parent;
        return value !== start_event_code;
      }
    ),
  legends: Yup.array()
    .of(
      Yup.object().shape({
        color: Yup.string().required("Color is required"),
        start_hour: Yup.number()
          .required("From is required")
          .min(0, "From must be at least 0")
          .integer("Whole number required"),
        end_hour: Yup.number()
          .required("To is required")
          .integer("Whole number required")
          .test(
            "min-greater-than-start-hour",
            "To must be greater than From",
            function (value) {
              const { start_hour } = this.parent;
              return typeof value === "number" && typeof start_hour === "number"
                ? value >= start_hour + 1
                : false;
            }
          ),
      })
    )
    .min(1, "At least one legend configuration is required"),
  groups: Yup.array()
    // .of(Yup.string())
    .of(
      Yup.object().shape({
        group_id: Yup.string(),
      })
    )
    .min(1, "At least one group must be selected"),
});
